module.exports = __webpack_public_path__ + "static/example-apps-54c18213468ff96be5880984cbe1c7e8.png";